import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import Page from '@pelckmans/elementis/components/page';

import IdentityContext from '../../../contexts/IdentityContext';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import ContentBody from '../../../layout/content/ContentBody';
import ContentHeader from '../../../layout/content/ContentHeader';
import ModuleAlerts from '../../../shared-components/alerts/ModuleAlerts';
import { withScrollThreshold } from '../../../shared-components/elementis/hoc/withScrollThreshold';
import ModuleContext from '../_contexts/ModuleContext';
import TocDataProvider from './_contexts/TocDataProvider';
import BulkBar from './components/BulkBar';
import PinnedMaterialSection from './components/pinned-material/PinnedMaterialSection';
import StudentMaterialSections from './components/student/MaterialSections';
import TeacherMaterialSection from './components/teacher/MaterialSection';
import TocPageHeader from './components/toc-page-header';
import TocMarketingNotifications from './components/TocMarketingNotifications';

import type { WithScrollThresholdProps } from '../../../shared-components/elementis/hoc/withScrollThreshold';
import ExerciseNodeCardSection from './components/ExerciseNodeCardSection';
interface TocProps extends WithScrollThresholdProps {}

export function Toc({ pastThreshold }: TocProps) {
  const { t } = useTranslation();

  useDocumentTitle(t('PAGES.TOC_LEVEL.DOCUMENT_TITLE'));

  const { selectedModule: module } = useContext(ModuleContext);
  const { identity } = useContext(IdentityContext);

  return (
    <Page>
      {module && <TocMarketingNotifications moduleId={module.id} />}
      <ContentHeader cover={<TocPageHeader density={pastThreshold ? 'compact' : 'normal'} />} />
      <ContentBody alerts={module ? <ModuleAlerts module={module} /> : null}>
        <ExerciseNodeCardSection />
        <PinnedMaterialSection />
        {identity.isTeacherAlike ? <TeacherMaterialSection /> : <StudentMaterialSections />}
      </ContentBody>
      <BulkBar />
    </Page>
  );
}

interface WrappedTocProps extends WithScrollThresholdProps {}

function WrappedToc({ pastThreshold }: WrappedTocProps) {
  return (
    <TocDataProvider>
      <Toc pastThreshold={pastThreshold} />
    </TocDataProvider>
  );
}

export default withScrollThreshold(WrappedToc);
